module.exports = __webpack_public_path__ + "../static/img/other.5579a088.png";